class TempVerifyRequest {
    TempVerifyURL(trx){
        return process.env.REACT_APP_BASEURL+"TempVerify/"+trx
    }

    TempVerifyBkashURL(trx){
        return process.env.REACT_APP_BASEURL+"TempVerifyBkash/"+trx
    }

    TempVerifyNagadURL(trx){
        return process.env.REACT_APP_BASEURL+"TempVerifyNagad/"+trx
    }
}
export const {TempVerifyURL, TempVerifyBkashURL, TempVerifyNagadURL}=new TempVerifyRequest();